import * as angular from "angular"
import { ICropping, IParam, isNumber, ParamKey, RegionId } from "../../omnia"
import { INtrReq } from "../../types"
import { CroppingAttr, ICroppingEditContext } from "@omnia/shared/fields/croppingAttr";
import { getParameters } from "@omnia/shared/parameters";


export class CroppingAttrs {

    static readonly croppingAttrNames = CroppingAttr.getNames();

    private _initialTarget: ICropping;

        public croppingAttrsEditContext: ICroppingEditContext;
        public targetYield: number;
        public targetpH: number;


    constructor(private req: INtrReq, private cropping: ICropping, private region: RegionId) {
        this.setup();
    }

    private setup() {

        this.targetYield = this.req.TargetYield;
        this.targetpH = this.req.LimeCropTargetpH;

        const parameters: { [key in ParamKey]?: IParam[] } = {};

        this._initialTarget = angular.extend({}, this.cropping);
        let target = angular.extend({}, this.cropping);

        this.croppingAttrsEditContext = {

            scotland: this.region == RegionId.Scotland,
            crop: this.cropping.Crop,

            target: target,

            getParameters: type => {

                var r = parameters[type];

                if (!r) {
                    r = parameters[type] = getParameters(type);
                }

                return r;
            }

        };

    }

    getCalculationParametersChanges(): { [key: string]: any } {

        let target = this.croppingAttrsEditContext.target;
        let init = this._initialTarget;

        let changes = CroppingAttrs.croppingAttrNames.reduce((changes, key) => {
            if (init[key] != target[key]) {
                changes[key] = target[key];
            }
            return changes;
        }, {});

        if (this.targetYield != this.req.TargetYield) {
            changes["TargetYield"] = this.targetYield;
        }

        if (isNumber(this.targetpH) && (this.targetpH != this.req.LimeCropTargetpH)) {
            changes["TargetpH"] = this.targetpH;
        }

        return (Object.keys(changes).length ? changes : undefined);
    }

}
